/* ============================================================
   C-Kan — Translations (ES default / EN)
   ============================================================ */
const translations = {
  es: {
    nav: {
      home: 'Inicio',
      tour: 'Tour',
      music: 'Música',
      bio: 'Biografía',
      shop: 'Tienda',
      official: 'Oficial',
      bookingCta: 'Booking',
      bookingManagement: 'Booking · Management',
      menuOpen: 'Abrir menú',
      menuClose: 'Cerrar menú',
      marquee: [
        '· NUEVO SENCILLO DISPONIBLE',
        '· BOOKING INTERNACIONAL',
        '· DESDE GUADALAJARA, MX',
        '· 1B+ STREAMS',
        '· MASTEREDTRAX',
      ],
    },

    hero: {
      statusOnTour: 'En gira · 2026',
      location: 'Guadalajara, MX → Mundo',
      eyebrow: 'El Perro de la C · Hip-Hop · Rap',
      // [emphasis1, word1, emphasis2, word2]
      titleSubParts: ['la', 'voz', 'de una', 'generación'],
      ledeHtml: 'Más de <strong>1B</strong> reproducciones. 20 años marcando la calle. El rapero mexicano más influyente de su generación.',
      ctaTour: 'Ver tour',
      ctaListen: 'Escuchar ahora',
      nextLabel: 'Próxima fecha',
      nextTickets: 'Boletos',
      statStreams: 'Streams',
      statVideos: 'Videos VEVO',
      statYears: 'Años de carrera',
      statCollabs: 'Colaboraciones',
      scroll: 'Scroll',
    },

    press: {
      label: 'Reconocido por',
    },

    events: {
      eyebrow: 'Tour 2026',
      titleA: 'Próximas',
      titleB: 'fechas',
      lede: 'C-Kan llega a las ciudades más importantes de México, Estados Unidos y Latino America. Reserva tu lugar antes de que se agoten.',
      loading: 'Cargando…',
      soon: 'Próximamente…',
      error: 'No se pudieron cargar los eventos.',
      tickets: 'Boletos',
      vip: 'VIP',
      soonBtn: 'Pronto',
      viewAll: 'Ver gira completa',
    },

    music: {
      eyebrow: 'Discografía',
      titleA: 'Escucha',
      titleB: 'la calle',
      latestRelease: 'Nuevo lanzamiento',
      featuredTag: 'Nuevo sencillo',
      featuredTitle: 'En Mi Barrio',
      featuredDesc: 'Lo más reciente del rap mexicano más influyente. Directo desde Guadalajara para el mundo entero.',
      spotifyTag: 'Oyentes mensuales',
      appleTag: 'Artista destacado',
      appleValue: 'Latino',
      youtubeTag: 'Suscriptores',
      nowPlaying: 'Ahora sonando',
      playLabel: 'Ver video oficial',
    },

    subscribe: {
      eyebrow: 'Inner Circle',
      titleA: 'Sé el primero',
      titleB: 'en saber',
      lede: 'Música nueva, fechas exclusivas y mensajes directos del estudio. Suscríbete y recibe las noticias antes que nadie.',
      perk1: 'Música antes que nadie',
      perk2: 'Acceso anticipado a boletos',
      perk3: 'Mensajes directos del artista',
      cta: 'Suscribirme',
      fineprint: 'Gratis · Cancela cuando quieras',
    },

    about: {
      eyebrow: 'Sobre el artista',
      titleA: 'Del barrio',
      titleB: 'al estrellato',
      lead: 'Su amor por los perros le da su nombre callejero. Hoy es uno de los exponentes más importantes del hip-hop y rap mexicano — pero C-Kan nunca olvida Guadalajara, el barrio que lo forjó.',
      body: 'A los 12 años se convirtió en el hombre de la casa tras la muerte de su padre. Sus líricas de exposición social han sido coreadas por miles de fanáticos, convirtiéndolo en profeta en su propia tierra y catapultándolo al estrellato internacional.',
      quote: 'C-Kan no es víctima de su entorno. Es un vocero de la realidad que los gobiernos ignoran y esconden ante la sociedad global.',
      statStart: 'Inicio de carrera',
      statStreams: 'Reproducciones',
      statVideos: 'Videos oficiales',
      statCollabs: 'Colaboraciones',
      cta: 'Leer biografía completa',
    },

    bioPage: {
      eyebrow: 'Guadalajara, Jalisco · Hip-Hop / Rap',
      statStart: 'Inicio',
      statStreams: 'Reproducciones',
      statVideos: 'Videos oficiales',
      statCollabs: 'Colaboraciones',
      p1Html: 'Su amor por los perros le da su nombre callejero y aunque ahora se destaca como uno de los exponentes más importantes del hip-hop y rap mexicano, C-Kan no olvida su barrio pobre en Guadalajara, Jalisco, donde creció. Ese a donde salía armado con una pistola 9mm por las noches para defenderse, y después adentrarse en el estudio con un beat que expusiera la experiencia vivida entre drogas y violencia. Pero C-Kan — que a los 12 años se convirtió en el hombre de la casa tras la muerte de su padre — no es una víctima de su entorno, sino un vocero de la realidad. Una realidad que los gobiernos ignoran y esconden ante la sociedad global.',
      p2Html: 'Callarse no es opción para C-Kan, y así como acusa al presidente de su país, Enrique Peña Nieto, por la represión de los suyos en el tema <em>Semillas</em>, también reprocha y corrige al mandatario del primer mundo Donald Trump, el maltrato hacia los que buscan una mejor vida, en <em>Soy ilegal</em>. Sus líricas de exposición social han sido coreadas por miles de fanáticos que lo han convertido en profeta en su propia tierra y catapultado al estrellato internacional.',
      p3Html: 'C-Kan es actualmente el artista mexicano más destacado de su género, con más de 50 videos oficiales en VEVO, algunos de los cuales superan los 100 millones de vistas. Ha encabezado importantes festivales a nivel mundial como Urbano Fest, Prudence Fest, Revolution Fest, Budweiser Made in America Festival y High Times Magazine: Cannabis Cup. Además ha colaborado con artistas de talla internacional como Baby Bash, Frankie J, South Park Mexican, Alika, Kinto Sol y Kevin Gates.',
      p4Html: 'Sus composiciones han llegado a la pantalla grande en cintas como <em>Compadres</em> y en series como <a href="https://youtu.be/oo5nnF2Bk4E" target="_blank" rel="noopener noreferrer">Ingobernable</a> para Netflix y <a href="https://youtu.be/fHyd_snDxDA" target="_blank" rel="noopener noreferrer">13 Esposas</a> para Blim. Los temas <em>M.E.X.I.C.O</em> y <em>La Calle Sabe de mi Nombre</em> se incluyen en <a href="https://youtu.be/ksalCVLJYT8" target="_blank" rel="noopener noreferrer">Tom Clancy\'s Ghost Recon Wildlands</a> y <a href="https://youtu.be/hLz02sgSzjc" target="_blank" rel="noopener noreferrer">Watch Dogs 2</a>.',
    },

    videosPage: {
      eyebrow: 'Videos oficiales · VEVO',
      heading: 'Videos',
      loading: 'Cargando videos…',
      error: 'No se pudieron cargar los videos.',
    },

    footer: {
      ctaEyebrow: 'Booking 2026',
      ctaTitle: 'Lleva a C-Kan a tu ciudad',
      ctaButton: 'Contactar booking',
      brandTag: 'Sitio oficial de C-Kan. Hip-Hop y rap desde Guadalajara para el mundo entero.',
      explore: 'Explora',
      booking: 'Booking',
      management: 'Management',
      copyright: 'Todos los derechos reservados',
      legal: 'MasteredTrax · Made in México',
    },

    lang: {
      aria: 'Cambiar idioma',
    },
  },

  en: {
    nav: {
      home: 'Home',
      tour: 'Tour',
      music: 'Music',
      bio: 'Biography',
      shop: 'Shop',
      official: 'Official',
      bookingCta: 'Booking',
      bookingManagement: 'Booking · Management',
      menuOpen: 'Open menu',
      menuClose: 'Close menu',
      marquee: [
        '· NEW SINGLE OUT NOW',
        '· WORLDWIDE BOOKING',
        '· FROM GUADALAJARA, MX',
        '· 1B+ STREAMS',
        '· MASTEREDTRAX',
      ],
    },

    hero: {
      statusOnTour: 'On tour · 2026',
      location: 'Guadalajara, MX → World',
      eyebrow: 'El Perro de la C · Hip-Hop · Rap',
      titleSubParts: ['the', 'voice', 'of a', 'generation'],
      ledeHtml: 'Over <strong>1B</strong> streams. 20 years owning the streets. Mexico\'s most influential rapper.',
      ctaTour: 'View tour',
      ctaListen: 'Listen now',
      nextLabel: 'Next show',
      nextTickets: 'Tickets',
      statStreams: 'Streams',
      statVideos: 'VEVO videos',
      statYears: 'Years in the game',
      statCollabs: 'Collaborations',
      scroll: 'Scroll',
    },

    press: {
      label: 'As featured in',
    },

    events: {
      eyebrow: 'Tour 2026',
      titleA: 'Upcoming',
      titleB: 'shows',
      lede: 'C-Kan is hitting the biggest cities across Mexico, the United States and Europe. Grab your spot before they sell out.',
      loading: 'Loading…',
      soon: 'Coming soon…',
      error: 'Could not load events.',
      tickets: 'Tickets',
      vip: 'VIP',
      soonBtn: 'Soon',
      viewAll: 'View full tour',
    },

    music: {
      eyebrow: 'Discography',
      titleA: 'Listen to',
      titleB: 'the streets',
      latestRelease: 'Latest Release',
      featuredTag: 'New single',
      featuredTitle: 'En Mi Barrio',
      featuredDesc: 'The newest drop from Mexico\'s most influential rap artist. Straight out of Guadalajara to the world.',
      spotifyTag: 'Monthly listeners',
      appleTag: 'Featured artist',
      appleValue: 'Latin',
      youtubeTag: 'Subscribers',
      nowPlaying: 'Now playing',
      playLabel: 'Watch official video',
    },

    subscribe: {
      eyebrow: 'Inner Circle',
      titleA: 'Be the first',
      titleB: 'to know',
      lede: 'New music, exclusive shows and direct messages from the studio. Subscribe and get the drops before anyone else.',
      perk1: 'Music before anyone else',
      perk2: 'Early access to tickets',
      perk3: 'Direct messages from the artist',
      cta: 'Subscribe',
      fineprint: 'Free · Unsubscribe anytime',
    },

    about: {
      eyebrow: 'About the artist',
      titleA: 'From the block',
      titleB: 'to the world',
      lead: 'His love for dogs gave him his street name. Today he is one of the leading voices of Mexican hip-hop and rap — but C-Kan never forgets Guadalajara, the neighborhood that shaped him.',
      body: 'At twelve he became the man of the house after his father\'s death. His socially-conscious lyrics have been chanted by thousands of fans, turning him into a prophet in his own land and launching him to international stardom.',
      quote: 'C-Kan is not a victim of his surroundings. He is a voice for a reality that governments ignore and hide from the world.',
      statStart: 'Career start',
      statStreams: 'Streams',
      statVideos: 'Official videos',
      statCollabs: 'Collaborations',
      cta: 'Read full biography',
    },

    bioPage: {
      eyebrow: 'Guadalajara, Jalisco · Hip-Hop / Rap',
      statStart: 'Since',
      statStreams: 'Streams',
      statVideos: 'Official videos',
      statCollabs: 'Collaborations',
      p1Html: 'His love for dogs gave him his street name. Today he stands as one of the most important voices in Mexican hip-hop and rap, yet C-Kan has never forgotten the poor neighborhood in Guadalajara, Jalisco where he grew up — the one he walked at night armed with a 9mm to defend himself, before heading back to the studio to turn the drugs and violence he lived through into beats and rhymes. But C-Kan — who at twelve became the man of the house after his father\'s death — is not a victim of his surroundings. He is a voice for a reality that governments ignore and hide from the world.',
      p2Html: 'Staying silent is not an option for C-Kan. He calls out his own country\'s president, Enrique Peña Nieto, for the repression of his people in the track <em>Semillas</em>, and just as sharply condemns first-world leader Donald Trump for the mistreatment of those seeking a better life in <em>Soy ilegal</em>. His socially charged lyrics are shouted by thousands of fans, turning him into a prophet in his own land and launching him onto the international stage.',
      p3Html: 'C-Kan is currently the most prominent Mexican artist of his genre, with more than 50 official videos on VEVO — several of them with over 100 million views. He has headlined major festivals around the world including Urbano Fest, Prudence Fest, Revolution Fest, Budweiser Made in America Festival and the High Times Magazine: Cannabis Cup. He has also collaborated with international artists such as Baby Bash, Frankie J, South Park Mexican, Alika, Kinto Sol and Kevin Gates.',
      p4Html: 'His music has made it to the big screen in films like <em>Compadres</em> and to series like <a href="https://youtu.be/oo5nnF2Bk4E" target="_blank" rel="noopener noreferrer">Ingobernable</a> for Netflix and <a href="https://youtu.be/fHyd_snDxDA" target="_blank" rel="noopener noreferrer">13 Esposas</a> for Blim. The songs <em>M.E.X.I.C.O</em> and <em>La Calle Sabe de mi Nombre</em> are featured in <a href="https://youtu.be/ksalCVLJYT8" target="_blank" rel="noopener noreferrer">Tom Clancy\'s Ghost Recon Wildlands</a> and <a href="https://youtu.be/hLz02sgSzjc" target="_blank" rel="noopener noreferrer">Watch Dogs 2</a>.',
    },

    videosPage: {
      eyebrow: 'Official videos · VEVO',
      heading: 'Videos',
      loading: 'Loading videos…',
      error: 'Could not load videos.',
    },

    footer: {
      ctaEyebrow: 'Booking 2026',
      ctaTitle: 'Bring C-Kan to your city',
      ctaButton: 'Contact booking',
      brandTag: 'Official site of C-Kan. Hip-Hop and rap straight from Guadalajara to the world.',
      explore: 'Explore',
      booking: 'Booking',
      management: 'Management',
      copyright: 'All rights reserved',
      legal: 'MasteredTrax · Made in México',
    },

    lang: {
      aria: 'Change language',
    },
  },
};

export default translations;
